<template >
  <body style="padding: 0; margin: 0;" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- HIDDEN PREHEADER TEXT -->
    <!-- TOPER: START -->
    <table width="100%" border="0" cellspacing="0" cellpadding="0" bgcolor="#6D27BF" style="background-color: #6D27BF1A;"
      class="mainTable mlBodyBackground" dir="ltr">
      <tr>
        <td height="18" class="spacingHeight-18" style="line-height: 18px; min-height: 18px;" align="center">
        </td>
      </tr>
    </table>
    <!-- TOPER: END -->
    <!-- CONTENT: START -->
    <table border="0" cellspacing="0" cellpadding="0"
      style="background-color: #fff; width: 100%; border-collapse: collapse;">
      <tbody>
        <tr>
          <td align="center">
            <!-- HEADER: START -->
            <table cellspacing="0" cellpadding="0" border="0" width="460"
              style="background-color: #fff; width: 100%; border-collapse: collapse; width: 460px;">
              <tr>
                <td height="24" class="spacingHeight-24" style="line-height: 24px; min-height: 24px">
                </td>
              </tr>
              <tr>
                <td>
                  <table cellspacing="0" cellpadding="0" border="0">
                    <tbody>
                      <tr>
                        <td align="center">
                          <img src="https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/Feedback%402x.png" width="52" height="52"
                            style="border-radius:52px;object-fit:cover;padding-right: 12px;" class="CToWUd"
                            data-bit="iit">
                        </td>
                        <td align="left" bgcolor="#FFFFFF"
                          style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;">
                          <p style="font-size:19px;color:#000;font-weight:900;margin:0">
                            Happily Leadership
                          </p>
                          <p
                            style="font-size:15px;color:#000; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;font-weight:400;margin:0">
                            Feedback Nudge
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td height="18" class="spacingHeight-18"
                  style="line-height: 18px; min-height: 18px; border-bottom: 1px solid #0000001a;">
                </td>
              </tr>
            </table>
            <!-- HEADER: END -->
            <!-- BODY: START -->
            <table cellspacing="0" cellpadding="0" border="0" width="396"
              style="background-color: #fff; width: 100%; border-collapse: collapse; width: 396px;">
              <tr>
                <td>
                  <table cellspacing="0" cellpadding="0" border="0"
                    style="background-color: #fff; width: 100%; border-collapse: collapse;">
                    <tr>
                      <td height="32" class="spacingHeight-32" style="line-height: 32px; min-height: 32px;">
                      </td>
                    </tr>
                    <tr>
                      <td style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;">
                        <span style="font-size: 16px; color: #6D27BF; font-weight: 700;">
                        {{ data.date }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td height="6" class="spacingHeight-6" style="line-height: 6px; min-height: 6px;">
                      </td>
                    </tr>
                    <tr>
                      <td style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;">
                        <span style="font-size: 30px; color: #000; font-weight: 900; line-height: 30px;">
                          Feedback from {{ data.email_name }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td height="16" class="spacingHeight-16" style="line-height: 16px; min-height: 16px;">
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            <table cellspacing="0" cellpadding="0" border="0" width="428" height="120" align="center"
              style="border-collapse: collapse; width: 428px; height: 120px;">
              <tr>
                <td align="center">
                  <img :src="data.image_rating" width="428" alt="rating banner" style="width: 428px; max-width: 428px; margin: auto"></img>
                </td>
              </tr>
            </table>
            <table cellspacing="0" cellpadding="0" border="0" width="396"
              style="background-color: #fff; width: 100%; border-collapse: collapse; width: 396px;">
              <tr>
                <td height="16" class="spacingHeight-16" style="line-height: 16px; min-height: 16px;">
                </td>
              </tr>
              <tr>
                <td align="center" style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; font-size: 18px; font-weight: 700; text-align: center;">
                  {{ data.rating_text }}
                </td>
              </tr>
              <tr>
                <td height="16" class="spacingHeight-16" style="line-height: 16px; min-height: 16px;">
                </td>
              </tr>
              <tr>
                <td>
                  <table cellspacing="0" cellpadding="0" border="0"
                    style="background-color: #00ACC115; width: 100%; border-collapse: collapse; border-radius: 4px;">
                    <tr>
                      <td
                        style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; padding: 16px 16px 0; font-size: 14px;">
                        <span style="font-weight: 700;">
                          {{ data.what_makes_rating }}
                          
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td height="8" class="spacingHeight-8" style="line-height: 8px; min-height: 8px;">
                      </td>
                    </tr>
                    <tr>
                      <td style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; padding: 0 16px 16px; font-size: 14px;">
                        {{ data.suggest_detail }}
                        <!-- keep doing better -->
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            
            <table v-for="(excel,index) in data.excels"  :key="'excel'+index" cellspacing="0" cellpadding="0" border="0" width="396" style="background-color: #fff; width: 100%; border-collapse: collapse; width: 396px;">
              <tr>
                <td>
                  <table cellspacing="0" cellpadding="0" border="0" style="width: 100%; border-collapse: collapse;">
                    <tr>
                      <td style="width: 42px"></td>
                      <td height="24" class="spacingHeight-24"
                        style="line-height: 24px; min-height: 24px; border-bottom: 1px solid #0000001a;">
                      </td>
                      <td style="width: 42px"></td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td height="24" class="spacingHeight-24" style="line-height: 24px; min-height: 24px;">
                </td>
              </tr> 
              <tr >
                <td>
                  <table cellspacing="0" cellpadding="0" border="0" style="width: 100%; border-collapse: collapse;">
                    <tr>
                      <td style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; font-size: 18px; font-weight: 900;">
                        {{data.language=='en'?'You excel at':'คุณเก่งในเรื่อง'}} {{data.language=='en'?excel.name:excel.name_th}}</td>
                      <td style="width: 94px; padding-left: 12px;">
                        <img :src="excel.progress" alt="">
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td height="8" class="spacingHeight-8" style="line-height: 8px; min-height: 8px;">
                </td>
              </tr>
              <tr>
                <td style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; font-size: 16px;">
                  {{ data.language=='en'?'The following areas were highlighted:':'ด้านที่ได้รับการเน้นขึ้นมาคือ:' }} 
                </td>
              </tr>
              <tr>
                <td height="12" class="spacingHeight-12" style="line-height: 12px; min-height: 12px;">
                </td>
              </tr>
              <tr v-for="choice,i in excel.choice" :key="i">
                <td>
                  <table cellspacing="0" cellpadding="0" border="0" style="width: 100%; border-collapse: collapse;">
                    <tr>
                      <td>
                        <!-- Add this class "blue", "orange" or nothing -->
                        <table :class="choice.classCss" cellspacing="0" cellpadding="0" border="0"
                          style="width: 100%; border-collapse: collapse;">
                          <tr>
                            <td style="width: 32px">
                              <img :src="choice.image_selected" style="padding: 10px 12px 10px 8px; height: 16px;" alt="">
                            </td>
                            <td style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; font-size: 13px">
                            {{data.language=='en'?choice.text_en:choice.text_th}}
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height="4" class="spacingHeight-4" style="line-height: 4px; min-height: 4px;">
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <table class="" cellspacing="0" cellpadding="0" border="0"
                    style="width: 100%; border-collapse: collapse;">
                    <tr>
                      <td style="width: 50px">
                        <img src="https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/chat_bubble_blue.png" style="padding: 18px 12px 10px 8px; height: 50px;" alt="">
                      </td>
                      <td style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; font-size: 15px">
                        <div style="padding: 16px 0">
                          {{ excel.detail?excel.detail:'' }}
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            <table v-for="(improves,index) in data.improves"  :key="index" cellspacing="0" cellpadding="0" border="0" width="396"
              style="background-color: #fff; width: 100%; border-collapse: collapse; width: 396px;">
              <tr>
                <td>
                  <table cellspacing="0" cellpadding="0" border="0" style="width: 100%; border-collapse: collapse;">
                    <tr>
                      <td style="width: 42px"></td>
                      <td height="24" class="spacingHeight-24"
                        style="line-height: 24px; min-height: 24px; border-bottom: 1px solid #0000001a;">
                      </td>
                      <td style="width: 42px"></td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td height="24" class="spacingHeight-24" style="line-height: 24px; min-height: 24px;">
                </td>
              </tr>
              <tr>
                <td>
                  <table cellspacing="0" cellpadding="0" border="0" style="width: 100%; border-collapse: collapse;">
                    <tr>
                      <td
                        style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; font-size: 18px; font-weight: 900;">
                       {{ data.language=='en'?'You can further improve at':'คุณสามารถพัฒนาเพิ่มเติมในเรื่อง' }} {{data.language=='en'?improves.name:improves.name_th }}</td>
                      <td style="width: 94px; padding-left: 12px;">
                        <img :src="improves.progress" alt="">
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td height="8" class="spacingHeight-8" style="line-height: 8px; min-height: 8px;">
                </td>
              </tr>
              <tr>
                <td style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; font-size: 16px;">
                 {{ data.language=='en'?'The following areas were highlighted:':'ด้านที่ได้รับการเน้นขึ้นมาคือ:' }} 
                </td>
              </tr>
              <tr>
                <td height="12" class="spacingHeight-12" style="line-height: 12px; min-height: 12px;">
                </td>
              </tr>
              <tr v-for="choice in improves.choice" :key="choice.key">
                <td>
                  <table cellspacing="0" cellpadding="0" border="0" style="width: 100%; border-collapse: collapse;">
                    <tr>
                      <td>
                        <table :class="choice.classCss" cellspacing="0" cellpadding="0" border="0" style="width: 100%; border-collapse: collapse;">
                          <tr>
                            <td style="width: 32px">
                              <img :src="choice.image_selected" style="padding: 10px 12px 10px 8px; height: 16px;" alt="">
                            </td>
                            <td style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; font-size: 13px">
                              {{ data.language=='en'?choice.text_en:choice.text_th }}
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height="4" class="spacingHeight-4" style="line-height: 4px; min-height: 4px;">
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <table class="" cellspacing="0" cellpadding="0" border="0"
                    style="width: 100%; border-collapse: collapse;">
                    <tr>
                      <td style="width: 50px">
                        <img src="https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/chat_bubble_orange.png" style="padding: 18px 12px 10px 8px; height: 50px;" alt="">
                      </td>
                      <td style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; font-size: 15px">
                        <div style="padding: 16px 0">
                          {{ improves.detail?improves.detail:'' }}
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>

            <!-- BODY: END -->
            <!-- BOTTOM: START -->
            <table cellspacing="0" cellpadding="0" border="0" width="428"
              style="background-color: #fff; width: 100%; border-collapse: collapse; width: 428px;">
              <tr>
                <td height="12" class="spacingHeight-12" style="line-height: 12px; min-height: 12px;">
                </td>
              </tr>
            </table>
            <table cellspacing="0" cellpadding="0" border="0" width="396"
              style="background-color: #fff; width: 100%; border-collapse: collapse; width: 396px;">

              <tr>
                <td height="24" class="spacingHeight-24" style="line-height: 24px; min-height: 24px;">
                </td>
              </tr>
              <tr>
                <td style="padding: 0">
                  <table cellspacing="0" cellpadding="0" border="0"
                    style="background-color: #fff; width: 100%; border-collapse: collapse;">
                    <tr>
                      <td align="center" class="m_8249704269731690095mlContentButton"
                        style="font-family:'Source Sans Pro',Arial,Helvetica,sans-serif">
                        <a href="https://app.happily.ai/EKJ6h9ETWPZ2jERP8" style="font-family: 'Lato', Arial, Helvetica, sans-serif;background-color:#00ACC1;border-radius:6px;color:#fff;font-weight:700; padding:15px 0 15px 0;text-align:center;text-decoration:none;width:100%;font-size: 16px; 
                          display: flex;
                          align-content: center;
                          justify-content: center;
                          align-items: center;" target="_blank" data-saferedirecturl="https://app.happily.ai/EKJ6h9ETWPZ2jERP8">
                          <span style="padding: 0 32px 0 52px; color:#fff">&nbsp;{{data.language=='en'?'REPLY TO':'ตอบกลับ'}} {{ data.from_name?data.from_name.toUpperCase() :''}}&nbsp;</span>
                          <img src="https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/open_in_app_white.png" width="24" alt="">
                        </a>
                      </td>
                    </tr>
                  </table>
                  <!-- <table cellspacing="0" cellpadding="0" border="0"
                    style="background-color: #fff; width: 100%; border-collapse: collapse;">
                    <tr>
                      <td align="center" class="m_8249704269731690095mlContentButton"
                        style="font-family:'Source Sans Pro',Arial,Helvetica,sans-serif">
                        <a href="https://happily.ai"
                          style="font-family: 'Lato', Arial, Helvetica, sans-serif;background-color:#00ACC1;border-radius:6px;color:#fff;display:inline-block;font-weight:700; padding:15px 0 15px 0;text-align:center;text-decoration:none;width:100%;font-size: 16px;"
                          target="_blank" data-saferedirecturl="https://happily.ai/th">
                          <span style="padding: 0 32px 0 52px; color:#fff">&nbsp;REPLY TO Wit Wat BK&nbsp;</span>
                          <img
                            src="https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/open_in_app_white.png"
                            width="24" alt="">
                        </a>
                      </td>
                    </tr>
                  </table> -->
                </td>
              </tr>
              <tr>
                <td height="8" class="spacingHeight-8" style="line-height: 8px; min-height: 8px;">
                </td>
              </tr>
              <tr>
                <td align="center"
                  style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; font-size: 15px; text-align: center; opacity: 0.7; font-style: italic;">
                  {{data.language=='en'?'Feedback is a thoughtful gift. Turn it into a conversation, starting with a thank you note.':'ฟีดแบ็กเป็นของขวัญที่ใส่ใจและผ่านการคิด แปรมาเป็นบทสนทนา โดยเริ่มต้นมาจากคำขอบคุณ'}}</td>
              </tr>
              <tr>
                <td height="32" class="spacingHeight-32"
                  style="line-height: 32px; min-height: 32px; border-bottom: 1px solid #0000001a;">
                </td>
              </tr>
              <tr>
                <td height="24" class="spacingHeight-24" style="line-height: 24px; min-height: 24px;">
                </td>
              </tr>
            </table>
            <table cellspacing="0" cellpadding="0" border="0" width="396"
              style="background-color: #fff; width: 100%; border-collapse: collapse; width: 396px;">
              <tr>
                <td style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; font-size: 16px;">
                  <span style="font-weight: 700;">This tip is related to </span>improving
                  <span style="font-weight: 700;">Feedback,</span>
                  getting the information we need to align and improve.
                </td>
              </tr>
              <tr>
                <td height="56" class="spacingHeight-56" style="line-height: 56px; min-height: 56px;">
                </td>
              </tr>
            </table>
            <!-- BOTTOM: END -->
          </td>
        </tr>
      </tbody>
    </table>
    <!-- CONTENT: END -->
    <!-- FOOTER: START -->
    <table width="100%" border="0" cellspacing="0" cellpadding="0" bgcolor="#6D27BF" style="background-color: #6D27BF1A;"
      class="mainTable mlBodyBackground" dir="ltr">
      <tr>
        <td class="mlTemplateContainer" align="center">
          <table align="center" border="0" class="mlContentTable mlContentTableDefault" cellpadding="0" cellspacing="0"
            width="460">
            <tr>
              <td class="mlContentTableCardTd">
                <table align="center" border="0" cellpadding="0" cellspacing="0" class="mlContentTable ml-default"
                  style="width: 460px; min-width: 460px;" width="460">
                  <tr>
                    <td>
                      <table role="presentation" cellpadding="0" cellspacing="0" border="0" align="center" width="460"
                        style="width: 460px; min-width: 460px;" class="mlContentTable">
                        <tr>
                          <td height="44" class="spacingHeight-44" style="line-height: 44px; min-height: 44px;">
                          </td>
                        </tr>
                      </table>
                      <table role="presentation" cellpadding="0" cellspacing="0" border="0" align="center" width="460"
                        style="width: 460px; min-width: 460px;" class="mlContentTable">
                        <tr>
                          <td align="center" style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;">
                            <p style="margin-top: 0px; margin-bottom: 0px; line-height: 16px;">
                              <span style="color: #000; opacity: 0.6;">Happily </span>
                              <span style="color: #F22F3C; font-weight: 700;">♥</span>
                              <span style="color: #000; opacity: 0.6;"> {{data.company_name}}</span>
                            </p>
                          </td>
                        </tr>
                      </table>
                      <table role="presentation" cellpadding="0" cellspacing="0" border="0" align="center" width="460"
                        style="width: 460px; min-width: 460px;" class="mlContentTable">
                        <tr>
                          <td height="44" class="spacingHeight-44" style="line-height: 44px; min-height: 44px;">
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <!-- FOOTER: END -->
  </body>

</template>


<script>
import CryptoJS from "crypto-js";
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
export default {
  name: "weekly-insights",
  data() {
    return {
      dateInput: "",
      // fullscreenLoading:true
     
    };
  },

  computed: {
    data() {
    
      return this.$store.getters["peerFeedback/data"];
    },
    fullscreenLoading() {
    
    return this.$store.getters["peerFeedback/loading"];
  },

  },
  created() {
    this.$store.dispatch("peerFeedback/getMessages",this.$route.params.id);
  },
  mounted() {
    if(this.$route.params.id){
     // console.log(this.$route.params.id);
    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.header {
  height: calc(80px - 32px);
  background: #6d27bf;
  padding: 16px;
  .box {
    color: #fff;
  }
}

body,
    html {
      padding: 0;
      margin: 0;
      font-family: 'Lato', Arial, Helvetica, sans-serif;
    }

    .background-of-check-list {
      background-color: #0000000D;
      border-radius: 4px;
    }

    .background-of-check-list.blue {
      background-color: #00ACC1;
      color: #fff;
    }

    .background-of-check-list.orange {
      background-color: #E45006;
      color: #fff;
    }
</style>
